export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const withCreds = { withCredentials: true };

export const fmtWhen = (d) => new Date(d).toLocaleString("en-GB");
export const slugify = (s) => s.replace(/[^a-zA-Z0-9]+/g, "-").toLowerCase();

export const childrenLabel = (children) => {
  if (children === "1") return "1 child";
  if (children.startsWith("Adult")) return children;
  return `${children} children`;
};

// Heuristic: treat @example.com addresses or names/messages flagged "test" as test data.
export const isTestEnquiry = (e) => {
  const email = (e.email || "").toLowerCase();
  const name = (e.name || "").toLowerCase();
  const msg = (e.message || "").toLowerCase();
  return email.includes("example.com") || email.includes("@test.") || /\btest\b/.test(name) || msg.includes("safe to delete");
};

export const OVERDUE_MS = 2 * 24 * 60 * 60 * 1000;
export const isOverdue = (e) => !e.replied && Date.now() - new Date(e.created_at).getTime() > OVERDUE_MS;
